import styled from 'styled-components';

// CONSTANTS
import { FUCHSIA_BLUE, MAIN_BLACK, ROYAL_BLUE_2, WHITE } from '@/constants/colors';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';
import { breakpoints } from '@/utility/breakpoints';

const downloadAppBg = getS3ImageUrl('/home/home-download-app-bg.png');

export const Container = styled.section`
  .content-section,
  &.content-section {
    &__wrapper {
      position: relative;
      margin: 0 auto;
      max-width: 1440px;
      padding-bottom: 40px;

      ${breakpoints.down('md')} {
        background-repeat: no-repeat;
        background-position: top right;
        background-size: auto;
      }

      ${breakpoints.down('sm')} {
        background-image: none;
      }

      ${breakpoints.up('sm')} {
        &::after {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          bottom: 40px;
          left: 50%;
          background-repeat: no-repeat;
          background-position: top right;
          background-size: auto;
        }
      }
    }
    &__page-content {
      padding-top: 80px;
      padding-bottom: 81px;

      &--channels-with-circles {
        max-height: 404px;

        ${breakpoints.down('md')} {
          max-height: 500px;
          padding-top: 50px;
          padding-bottom: 50px;
        }
      }

      &--home-download-app {
        position: relative;

        .content-section__image {
          top: auto;
        }

        .MuiGrid-container {
          position: relative;
          z-index: 2;
        }

        &::after {
          content: url(${downloadAppBg});
          position: absolute;
          bottom: 0;
          right: 0;
          z-index: 1;
        }
      }

      ${breakpoints.down('md')} {
        max-height: 500px;
        padding-top: 50px;
        padding-bottom: 50px;

        &--home-download-app {
          max-height: none;
        }
      }

      ${breakpoints.down('sm')} {
        max-height: none;
        padding-top: 32px;
        padding-bottom: 32px;
      }
    }
    &__title {
      margin-top: 12px;
    }
    &__subtitle {
      line-height: 17px;
    }
    &__description {
      margin-top: 16px;
    }
    &__button {
      margin-top: 32px;
      max-width: 346px;
      z-index: 1;
      ${breakpoints.down('sm')} {
        display: flex;
        margin-left: auto;
        margin-right: auto;
      }
    }
    &__image {
      display: block;
      margin: 0 auto;
      ${breakpoints.up('md')} {
        position: absolute;
        top: 0;
      }
    }
    &--blue {
      background-color: ${ROYAL_BLUE_2};
      .content-section__page-content {
        color: ${WHITE};
      }
    }
    &--white {
      background-color: ${WHITE};
      .content-section__page-content {
        color: ${p => p.theme.palette.text.primary};
      }
    }
    &--purple {
      background-color: ${FUCHSIA_BLUE};
      .content-section__page-content {
        color: ${WHITE};
      }
    }
    &--black {
      background-color: ${MAIN_BLACK};
      .content-section__page-content {
        color: ${WHITE};
      }
    }
  }
`;

export default Container;
